import {useEffect, useState} from 'react';
import {Modal, Button, Form, Input, Popconfirm, message, Collapse} from 'antd';
import {useApi} from "../provider/ApiProvider";
import CustomerSelector from "../components/CustomerSelector";
import TextEditor from "../components/TextEditor";
import PlatformSelector from "../components/PlatformSelector";

const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
};

const {TextArea} = Input;

export default function InfoAppDialog({open, data, onChange, onClose}){

    const {api, openToast} = useApi();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        form.setFieldsValue(data);
    },[data])

    const handleOk = () => {

    };

    const handleCancel = () => {
        onClose()
    };

    const onFinish = async (values) => {
        if(data === null){
            setLoading(true);
            await api.post('/infoAppRouter/info/store/', values).then(resp => {
                openToast('success', 'Metin Eklendi')
                onChange();
                onClose();
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            })
        }else{
            setLoading(true);
            await api.put('/infoAppRouter/info/update/' + data.id, values).then(resp => {
                openToast('success', 'Metin Güncellendi')
                onChange();
                onClose();
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            })
        }

    };

    const onFinishFailed = (errorInfo) => {

    }

    const onDelete = (record) => {


    }



    return (
        <Modal
            title={(data === null || data === undefined) ? "Firma / Şube Ekle" : "Düzenle"}
            visible={open} okType={"submit"}
            width={1000}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <>
                </>
            ]}
        >
            <Form
                form={form}
                name="basic"
                initialValues={{
                    remember: true,
                }}
                onFinish={(values) => onFinish(values)}
                onFinishFailed={() => {}}
            >
                <Form.Item
                    label="Müşteri/Kuruluş"
                    name="CustomerId"
                    rules={[
                        {
                            required: true,
                            message: 'Seç',
                        },
                    ]}
                >
                    <CustomerSelector
                        value={form.getFieldValue('CustomerId')}
                        onChange={(value) =>form.setFieldsValue({ CustomerId: value })}
                    />
                </Form.Item>
                <Form.Item
                    label="Metin"
                    name="content"
                    rules={[
                        {
                            required: true,
                            message: 'Metin giriniz',
                        },
                    ]}
                >
                    <TextEditor
                        value={form.getFieldValue('content')}
                        onChange={(value) =>form.setFieldsValue({ content: value })}
                        height={'400px'}
                    />
                </Form.Item>

                <div className="form-button">
                    <Button className="submit-btn" loading={loading}  type="primary" htmlType="submit">
                        Kaydet
                    </Button>
                </div>
            </Form>
        </Modal>

    )
}
